import React from "react";
import { motion } from "framer-motion";
import {
  FaReact,
  FaNodeJs,
  FaWordpress,
  FaShopify,
  FaMobileAlt,
  FaRobot,
  FaBrain,
  FaCamera,
  FaPlane,
  FaStar,
  FaGraduationCap,
} from "react-icons/fa";

const works = [
  {
    title: "Web Development",
    items: [
      "WordPress Websites",
      "Shopify Stores",
      "React Applications",
      "Node.js Backends",
      "E-commerce Platforms",
    ],
    icon: <FaReact />,
  },
  {
    title: "AI & Machine Learning",
    items: [
      "Machine Learning Websites",
      "LLM-based Applications",
      "Computer Vision Systems",
      "Artificial Intelligence Solutions",
    ],
    icon: <FaBrain />,
  },
  {
    title: "Specialized Systems",
    items: [
      "Drone Control Software",
      "Ratings & Review Systems",
      "Student Learning Systems",
      "Prank Applications",
    ],
    icon: <FaPlane />,
  },
  {
    title: "Mobile Applications",
    items: [
      "Vaccinator Mobile App",
      "React Native Frontend",
      "NestJS Backend",
    ],
    icon: <FaMobileAlt />,
  },
];

const WorkSection = () => {
  return (
    <section className="py-20">
      {/* Section Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12 text-center"
      >
        <h2 className="text-3xl md:text-4xl font-semibold text-white">
          My Work
        </h2>
        <p className="mt-3 text-gray-400 max-w-2xl mx-auto">
          A snapshot of the products, platforms, and intelligent systems I’ve
          built across web, AI, and mobile.
        </p>
      </motion.div>

      {/* Work Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {works.map((work, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-6 hover:border-blue-500/40 transition"
          >
            {/* Glow on hover */}
            <div className="absolute inset-0 rounded-2xl bg-blue-500/10 opacity-0 group-hover:opacity-100 blur-xl transition" />

            <div className="relative z-10">
              {/* Title */}
              <div className="flex items-center gap-3 mb-4">
                <span className="text-blue-400 text-xl">{work.icon}</span>
                <h3 className="text-xl font-semibold text-white">
                  {work.title}
                </h3>
              </div>

              {/* List */}
              <ul className="space-y-2 text-gray-300 text-sm">
                {work.items.map((item, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <FaStar className="text-blue-400 text-xs" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WorkSection;
